import dayjs from 'dayjs';
import { dateTimeFormat } from '../contstant';

export default function downloadCSV(csvStr: string, nameAddition = '', filePrefix = 'users') {
  const hiddenElement = document.createElement('a');
  const currentDateTime = dayjs().format(dateTimeFormat);

  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csvStr)}`;
  hiddenElement.target = '_blank';
  hiddenElement.download = `${filePrefix}-${currentDateTime}${nameAddition}.csv`;

  hiddenElement.style.display = 'none'; // in case it needs to be added (for older browsers)
  document.body.append(hiddenElement);
  hiddenElement.click();
  hiddenElement.remove(); // cleanup
}
